import { useCallback, useState } from 'react'

export const useModal = (): {
    closeHandlerReady: boolean
    closeModal: () => void
    isModalOpen: boolean
    openModal: () => void
    triggerClose: () => void
} => {
    const [isModalOpen, setIsModalOpen] = useState(false)

    const [closeHandlerReady, setCloseHandlerReady] = useState(false)

    const openModal = useCallback(() => {
        setIsModalOpen(true)
        setCloseHandlerReady(false)
    }, [])

    const closeModal = useCallback(() => {
        setIsModalOpen(false)
        setCloseHandlerReady(false)
    }, [])

    const triggerClose = useCallback(() => {
        setCloseHandlerReady(true)
    }, [])

    return {
        isModalOpen,
        openModal,
        closeModal,
        closeHandlerReady,
        triggerClose,
    }
}
